<template>
    <div class="reset-pwd">
        <div class="title">重置密码</div>

        <a-form-model layout="horizontal" :model="form" :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }">
            <a-form-model-item label="手机号">
                <a-input v-model="form.phone" placeholder="请输入手机号"> </a-input>
            </a-form-model-item>
            <a-form-model-item label="验证码">
                <a-input v-model="form.code" placeholder="请输入验证码">
                    <div class="send-code-btn" slot="suffix">发送验证码</div>
                </a-input>
            </a-form-model-item>
            <a-form-model-item label="新密码">
                <a-input v-model="form.password" type="password" placeholder="请输入密码"> </a-input>
            </a-form-model-item>
            <a-form-model-item label="确认密码">
                <a-input v-model="form.password" type="password" placeholder="请输入密码"> </a-input>
            </a-form-model-item>
        </a-form-model>

        <button class="reset-btn" @click="reset">重置密码</button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {}
        };
    },
    methods: {
        reset() {
            this.$emit('back');
        }
    }
};
</script>

<style lang="scss" scoped>
.reset-pwd {
    width: 100%;
    padding: 27px 64px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
        font-family: PingFangSC-Semibold;
        font-size: 22px;
        color: #333333;
        line-height: 32px;
        font-weight: 600;
        margin-bottom: 76px;
        text-align: center;
    }

    ::v-deep {
        .ant-form {
            color: #999;
            width: 100%;

            .ant-form-item-control-wrapper input {
                height: 40px;
                font-size: 14px;
                border: 0 none;
                background: #f8f8f8;
                border-radius: 24px;
                padding-left: 16px;
                &:focus {
                    box-shadow: none;
                }
            }

            .send-code-btn {
                position: relative;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #005bac;
                cursor: pointer;
                padding-left: 16px;

                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 1px;
                    height: 16px;
                    background: #d9d9d9;
                }
            }
        }
    }

    .reset-btn {
        width: 320px;
        height: 48px;
        margin-top: 80px;
        border: 0 none;
        outline: 0;
        background: #005096;
        box-shadow: 0 5px 10px 0 rgba(0, 80, 150, 0.2);
        border-radius: 24px;
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #ffffff;
        font-weight: 700;
        cursor: pointer;
    }
}
</style>
